import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api/client';

const ExpenseReport = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get(`/api/spvs/${id}/expenses/`).then((r) => setData(r.data)).catch(() => setError(true)); }, [id]);

  const open = async (e) => {
    const res = await api.get(e.invoice_url, { responseType: 'blob' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(res.data); a.download = `invoice-${e.id}.pdf`; a.click();
  };

  if (error) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p role="alert">The expense report is available to shareholders of this company.</p><Link to="/dashboard">Back</Link></main>;
  if (!data) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1rem' }}>
      <p><Link to="/dashboard">← Dashboard</Link></p>
      <h1>Expenses — {data.spv}</h1>
      <p>Project costs are recovered at cost and deducted before distribution. Total: ₹{Number(data.total).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
      {data.expenses.length === 0 ? <p>No expenses recorded.</p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Date</th><th align="left">Category</th><th align="left">Vendor</th><th align="right">Amount</th><th /></tr></thead>
          <tbody>{data.expenses.map((e) => (
            <tr key={e.id}><td>{e.date}</td><td>{e.category}</td><td>{e.vendor}</td><td align="right">₹{Number(e.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
              <td><button onClick={() => open(e)}>Invoice</button></td></tr>
          ))}</tbody>
        </table>
      )}
    </main>
  );
};

export default ExpenseReport;
